module.exports = __webpack_public_path__ + "static/roboto-v20-cyrillic_latin-500-2e0bf09ac4b4cb07efe92b9df7b39d64.woff2";